import { Card, CardContent } from '@/components/ui/card';
import { UserPlus, Users, Package } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const LandingAIFeatures: React.FC<{ embedded?: boolean }> = ({ embedded }) => {
  const { t } = useTranslation();

  const steps = (t('landing.howItWorks.steps', { returnObjects: true }) as Array<{ step: string; title: string; description: string }>);
  const icons = [UserPlus, Users, Package];

  if (embedded) {
    return (
      <div>
        <div className="text-center mb-5 md:mb-8">
          <h3 className="text-lg md:text-xl font-medium text-muted-foreground">
            {t('landing.howItWorks.getStartedTitle')}
          </h3>
        </div>
        <div className="grid md:grid-cols-3 gap-10 md:gap-12">
          {steps.map((step, index) => {
            const IconComponent = icons[index] || UserPlus;
            return (
              <div key={index} className="text-center space-y-3 px-3">
                <div className="w-16 h-16 bg-primary/10 text-primary rounded-full flex items-center justify-center mx-auto mb-4 relative">
                  <IconComponent className="w-6 h-6" />
                  <span className="absolute -top-2 -right-2 w-5 h-5 bg-primary text-primary-foreground rounded-full flex items-center justify-center text-[10px] font-bold">
                    {step.step}
                  </span>
                </div>
                <h3 className="text-lg md:text-xl font-semibold text-foreground mb-1">{step.title}</h3>
                <p className="text-sm md:text-base text-muted-foreground leading-relaxed">{step.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  return null;
};
